var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoYouKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3619",
    "data-name": "Group 3619",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161.153,
    height: 161.143,
    viewBox: "0 0 161.153 161.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    width: 161.153,
    height: 161.143,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3619-2",
    "data-name": "Group 3619",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50180",
    "data-name": "Path 50180",
    d: "M161.144,80.572A80.572,80.572,0,1,1,80.572,0a80.572,80.572,0,0,1,80.572,80.572",
    fill: "#dfefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50181",
    "data-name": "Path 50181",
    d: "M159.008,146.79H64.08a.087.087,0,0,1-.088-.088V75.061a.088.088,0,0,1,.088-.088h94.928a.088.088,0,0,1,.088.088V146.7a.087.087,0,0,1-.088.088m-94.84-.176H158.92V75.149H64.168Z",
    fill: "#a0c18a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2136",
    "data-name": "Rectangle 2136",
    width: 88.972,
    height: 59.965,
    transform: "translate(67.058 78.027)",
    fill: "#e6d0be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2137",
    "data-name": "Rectangle 2137",
    width: 88.972,
    height: 59.965,
    transform: "translate(67.058 78.027)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138",
    "data-name": "Rectangle 2138",
    width: 81.098,
    height: 39.058,
    transform: "translate(71.189 85.109)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50182",
    "data-name": "Path 50182",
    d: "M113.331,141.995a1.787,1.787,0,1,1-1.787-1.779,1.783,1.783,0,0,1,1.787,1.779",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50183",
    "data-name": "Path 50183",
    d: "M151.551,156.267H63.294a7.581,7.581,0,0,1-7.545-7.6.088.088,0,0,1,.088-.088H159.008a.087.087,0,0,1,.088.088,7.581,7.581,0,0,1-7.545,7.6m-95.625-7.512a7.4,7.4,0,0,0,7.368,7.336h88.257a7.4,7.4,0,0,0,7.368-7.336Z",
    fill: "#a0c18a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50184",
    "data-name": "Path 50184",
    d: "M134.021,155.489a.088.088,0,0,1,0-.176,5.852,5.852,0,0,0,5.823-5.867.088.088,0,0,1,.176,0,6.028,6.028,0,0,1-6,6.043",
    fill: "#a0c18a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50185",
    "data-name": "Path 50185",
    d: "M99.225,150.443a3.181,3.181,0,0,1-3.169,3.192H84.9a3.181,3.181,0,0,1-3.169-3.192Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139",
    "data-name": "Rectangle 2139",
    width: 79.256,
    height: 109.686,
    transform: "translate(70.567 6.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50186",
    "data-name": "Path 50186",
    d: "M147.492,118.114H68.236a.087.087,0,0,1-.088-.088V15.442a.088.088,0,1,1,.176,0v102.5H147.4V8.428l-25.381-.093a.088.088,0,1,1,0-.176h0l25.468.093a.087.087,0,0,1,.088.088V118.026a.087.087,0,0,1-.088.088",
    fill: "#a0c18a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2140",
    "data-name": "Rectangle 2140",
    width: 27.025,
    height: 2.087,
    transform: "translate(101.707 84.738)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2141",
    "data-name": "Rectangle 2141",
    width: 33.225,
    height: 2.087,
    transform: "translate(105.9 89.952)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2142",
    "data-name": "Rectangle 2142",
    width: 31.967,
    height: 2.087,
    transform: "translate(101.706 95.167)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2143",
    "data-name": "Rectangle 2143",
    width: 33.432,
    height: 2.087,
    transform: "translate(108.858 61.774)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144",
    "data-name": "Rectangle 2144",
    width: 31.967,
    height: 2.087,
    transform: "translate(100.802 66.989)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2145",
    "data-name": "Rectangle 2145",
    width: 37.537,
    height: 2.087,
    transform: "translate(100.802 72.204)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2146",
    "data-name": "Rectangle 2146",
    width: 29.362,
    height: 2.087,
    transform: "translate(108.977 40.202)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2147",
    "data-name": "Rectangle 2147",
    width: 31.849,
    height: 2.087,
    transform: "translate(100.92 45.417)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2148",
    "data-name": "Rectangle 2148",
    width: 41.37,
    height: 2.087,
    transform: "translate(100.92 50.632)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50187",
    "data-name": "Path 50187",
    d: "M94.8,102.045H77.919a.088.088,0,0,1-.088-.088V85.089A.088.088,0,0,1,77.919,85H94.8a.087.087,0,0,1,.088.088v16.868a.087.087,0,0,1-.088.088m-16.789-.176h16.7V85.177h-16.7Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50188",
    "data-name": "Path 50188",
    d: "M85.452,99.407l-5.284-4.8L81.8,92.591l3.35,2.677,5.257-7.629,2.138,1.472Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50189",
    "data-name": "Path 50189",
    d: "M94.8,77.721H77.919a.088.088,0,0,1-.088-.088V60.765a.088.088,0,0,1,.088-.088H94.8a.087.087,0,0,1,.088.088V77.633a.087.087,0,0,1-.088.088m-16.789-.176h16.7V60.853h-16.7Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50190",
    "data-name": "Path 50190",
    d: "M85.452,75.083l-5.284-4.8L81.8,68.267l3.35,2.677,5.257-7.629,2.138,1.472Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50191",
    "data-name": "Path 50191",
    d: "M94.8,56.149H77.919a.089.089,0,0,1-.088-.088V39.192a.089.089,0,0,1,.088-.088H94.8a.088.088,0,0,1,.088.088V56.061a.088.088,0,0,1-.088.088m-16.789-.176h16.7V39.281h-16.7Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50192",
    "data-name": "Path 50192",
    d: "M85.452,53.511l-5.284-4.8L81.8,46.695l3.35,2.677,5.257-7.629,2.138,1.472Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50193",
    "data-name": "Path 50193",
    d: "M121.675,18.725H118.2v9.564h-1.918V18.725h-3.439V17.167h8.827Z",
    fill: "#40484c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50194",
    "data-name": "Path 50194",
    d: "M128.446,25.7h-4.311l-.9,2.59h-2.009l4.2-11.122h1.735l4.211,11.122h-2.018Zm-3.768-1.558H127.9l-1.612-4.614Z",
    fill: "#40484c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50195",
    "data-name": "Path 50195",
    d: "M136.464,21.185l2.339-4.018h2.231l-3.362,5.515,3.439,5.607h-2.255l-2.392-4.079-2.4,4.079h-2.247l3.447-5.607-3.37-5.515h2.231Z",
    fill: "#40484c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 20.446,
    height: 1.902,
    transform: "translate(78.546 17.165)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 25.999,
    height: 1.902,
    transform: "translate(78.547 21.563)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 25.999,
    height: 1.902,
    transform: "translate(78.547 25.96)",
    fill: "#e8f7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50196",
    "data-name": "Path 50196",
    d: "M141.121,32.1H77.975a.088.088,0,0,1,0-.176h63.146a.088.088,0,0,1,0,.176",
    fill: "#a0c18a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50197",
    "data-name": "Path 50197",
    d: "M80.134,144.792q-1.923-2.6-3.868-5.192a40.721,40.721,0,0,0-3.6-4.364A36.316,36.316,0,0,0,64.49,129.2c-6-3.336-12.622-5.406-19.243-7.1-6.317-1.619-13.052-2.275-19.433-.618a28.319,28.319,0,0,0-11.335,6.051A79.207,79.207,0,0,0,79.3,161.143a80.012,80.012,0,0,0,11.864-.882c-3.576-5.228-7.271-10.374-11.034-15.469",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50198",
    "data-name": "Path 50198",
    d: "M59.6,56.215c-2.266-4.634-3.995-7.136-6.976-8.144-4.006-1.354-7.838,1.292-8.234,1.574-.253.18-4,2.525-4.167,6.97a12.226,12.226,0,0,0,5.744,10.936l1.087,9.644a5.642,5.642,0,0,0,6.238,4.974l.7-.079a5.642,5.642,0,0,0,4.974-6.238L58.24,69.41c1.945-.386,3.435-1.13,3.946-2.2.914-1.907.082-5.543-2.587-11",
    fill: "#e2a18d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50199",
    "data-name": "Path 50199",
    d: "M58.311,69.335a.088.088,0,0,1-.087-.076L57.9,66.908a.088.088,0,1,1,.175-.025l.328,2.352a.088.088,0,0,1-.075.1h-.012",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50200",
    "data-name": "Path 50200",
    d: "M54.3,62.646a.086.086,0,0,1-.058-.022c-.3-.262-.568-.5-.85-.759-.23-.208-.467-.423-.734-.659a.088.088,0,1,1,.116-.132c.268.237.506.452.736.66.282.255.548.5.848.758a.087.087,0,0,1,.008.124.085.085,0,0,1-.066.03",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50201",
    "data-name": "Path 50201",
    d: "M34.436,59.409a4.683,4.683,0,0,1,2.9-5.952l.011,0a4.024,4.024,0,0,1,2.931-6.81,4.025,4.025,0,0,1,5.89-4.581,4.694,4.694,0,0,1,8.915-.65c.11-.049.221-.1.337-.136A4.033,4.033,0,1,1,58.049,48.9c-.061.021-.122.035-.183.053.989,3.813-2.806,5.583-3.02,5.72q1.531,2.333,3.062,4.664c-.589.4-1.278.932-1.866,1.336-.981-1.665-1.92-2.122-2.98-1.963a3.118,3.118,0,0,0-2.281,3.777,3.921,3.921,0,0,0,2.948,3.091c-1.582.572-3.254,1.125-5.014,1.643q-1.378.407-2.706.749a11.206,11.206,0,0,1-6.91-5.411,4.684,4.684,0,0,1-4.663-3.152",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50202",
    "data-name": "Path 50202",
    d: "M4.834,123.809c19.889,4.425,31.668,7.231,36.041,8.148a8.253,8.253,0,0,0,2.337.2c3.969-.251,5.2-3.408,9.252-5.576,4.6-2.461,8.582-1.242,8.858-2.545.192-.907-1.181-1.789-4.409-2.423h0c2.508.2,5.921.322,6.027-1.064.037-1.607-3.956-2.222-6.389-2.475,2.945.307,4.6-.411,4.47-1.2-.21-1.24-2.439-2.01-6.348-2.265,2.749-.578,3.329-1.128,3.042-1.795-.526-1.219-3.743-1.368-6.608-1.064a16.637,16.637,0,0,0-7.089,2.636h0c-13.608-4.543-22.628-7.466-33.544-11.359-2.233-.8-5.64,20.78-5.639,20.78",
    fill: "#ffbeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50203",
    "data-name": "Path 50203",
    d: "M19.195,82.205C1.1,103.22-4.5,119.142,3.667,123.44c4.628,2.435,18.4-7.308,31.417-25.015-5.649-5.161-8.9-10.154-15.889-16.22",
    fill: "#ffbeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50204",
    "data-name": "Path 50204",
    d: "M86.22,84.42c22.594,4.805,40.338,9.674,38.4,16.923-4.1,15.345-21.147,7.458-36.3,7.323-.571-6.222-1.575-16.7-2.1-24.246",
    fill: "#ffbeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50205",
    "data-name": "Path 50205",
    d: "M105.278,98.774s-5.705-15.345-8.155-23.693c-2.574-8.767-5.1-22.085-3.229-22.414,1.064-.187,1.784,1.558,3.4,6.35a2.231,2.231,0,0,1,1.82-1.182,2.14,2.14,0,0,1,2.016,1.27c.046-.114.571-1.331,1.575-1.513a2.357,2.357,0,0,1,2.478,1.068,2.447,2.447,0,0,1,1.647-1.414,2.194,2.194,0,0,1,2.429,1.431c.517,1.861,1.946,7.42,2.971,10.041,2.017,5.157,11.639,22.511,12.584,30.735-6.988-1.584-19.533-.679-19.533-.679",
    fill: "#ffbeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50206",
    "data-name": "Path 50206",
    d: "M107.2,61.313a.088.088,0,0,1-.013-.175L108.8,60.9a.088.088,0,0,1,.025.174l-1.615.235H107.2",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50207",
    "data-name": "Path 50207",
    d: "M103.1,61.923a.088.088,0,0,1-.087-.078.089.089,0,0,1,.077-.1l1.834-.207a.086.086,0,0,1,.1.077.088.088,0,0,1-.077.1l-1.834.207h-.01",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50208",
    "data-name": "Path 50208",
    d: "M99.11,62.345a.088.088,0,0,1-.013-.175c.3-.044.574-.082.846-.12s.545-.075.846-.119a.088.088,0,1,1,.025.174c-.3.044-.574.082-.847.12s-.543.075-.844.119H99.11",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50209",
    "data-name": "Path 50209",
    d: "M95.859,63.1a.088.088,0,0,1-.019-.174l1.582-.351a.088.088,0,1,1,.038.172l-1.582.351-.019,0",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50210",
    "data-name": "Path 50210",
    d: "M11.4,86.819a19.688,19.688,0,0,1,11.5-9.571A68.072,68.072,0,0,1,50.226,74.6c21.36,2.269,45.545,9.821,45.545,9.821v31.24L80.2,112.414l-3.4,25.518L13.106,127.087l2.718-17.981L4.834,99.179Z",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50211",
    "data-name": "Path 50211",
    d: "M156.924,40.058a6.628,6.628,0,1,0-1.057,9.314,6.628,6.628,0,0,0,1.057-9.314",
    fill: "#efbc73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50212",
    "data-name": "Path 50212",
    d: "M155.406,41.268a4.687,4.687,0,1,0-.748,6.586,4.688,4.688,0,0,0,.748-6.586",
    fill: "#e0aa63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50213",
    "data-name": "Path 50213",
    d: "M151.947,49.19a6.9,6.9,0,0,1-.771-.043,6.713,6.713,0,1,1,.771.043m-.02-13.254A6.537,6.537,0,1,0,157.05,38.4a6.507,6.507,0,0,0-5.123-2.464",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50214",
    "data-name": "Path 50214",
    d: "M135.438,40.416a5.889,5.889,0,1,0-.939,8.275,5.889,5.889,0,0,0,.939-8.275",
    fill: "#efbc73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50215",
    "data-name": "Path 50215",
    d: "M134.089,41.49a4.164,4.164,0,1,0-.664,5.852,4.164,4.164,0,0,0,.664-5.852",
    fill: "#e0aa63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50216",
    "data-name": "Path 50216",
    d: "M131.01,48.536a5.971,5.971,0,1,1,3.717-1.3,5.968,5.968,0,0,1-3.717,1.3M131,36.763a5.8,5.8,0,1,0,4.544,2.185A5.772,5.772,0,0,0,131,36.763",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50217",
    "data-name": "Path 50217",
    d: "M135.1,65.356a6.628,6.628,0,1,0-1.057,9.314,6.628,6.628,0,0,0,1.057-9.314",
    fill: "#efbc73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50218",
    "data-name": "Path 50218",
    d: "M133.58,66.565a4.687,4.687,0,1,0-.747,6.586,4.686,4.686,0,0,0,.747-6.586",
    fill: "#e0aa63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50219",
    "data-name": "Path 50219",
    d: "M130.121,74.488a6.9,6.9,0,0,1-.771-.043,6.713,6.713,0,1,1,.771.043m-.02-13.254a6.537,6.537,0,1,0,5.123,2.464,6.507,6.507,0,0,0-5.123-2.464",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2152",
    "data-name": "Rectangle 2152",
    width: 26.251,
    height: 32.32,
    transform: "translate(120.783 129.532) rotate(-70.641)",
    fill: "#807f82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2153",
    "data-name": "Rectangle 2153",
    width: 4.089,
    height: 4.089,
    transform: "translate(146.167 136.609) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50220",
    "data-name": "Path 50220",
    d: "M159.967,115.513,129.474,104.8l1.186-8.024,30.493,10.715Z",
    fill: "#807f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50221",
    "data-name": "Path 50221",
    d: "M157.6,112.752l-25.615-9,.657-4.446,25.615,9Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154",
    "data-name": "Rectangle 2154",
    width: 4.089,
    height: 4.089,
    transform: "translate(148.247 130.688) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2155",
    "data-name": "Rectangle 2155",
    width: 4.089,
    height: 4.089,
    transform: "translate(150.328 124.767) rotate(-70.634)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2156",
    "data-name": "Rectangle 2156",
    width: 4.089,
    height: 4.089,
    transform: "translate(152.408 118.846) rotate(-70.634)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2157",
    "data-name": "Rectangle 2157",
    width: 4.089,
    height: 4.089,
    transform: "translate(140.402 134.583) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2158",
    "data-name": "Rectangle 2158",
    width: 4.089,
    height: 4.089,
    transform: "translate(142.482 128.662) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2159",
    "data-name": "Rectangle 2159",
    width: 4.089,
    height: 4.089,
    transform: "translate(144.563 122.742) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    width: 4.089,
    height: 4.089,
    transform: "translate(146.643 116.821) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2161",
    "data-name": "Rectangle 2161",
    width: 4.089,
    height: 4.089,
    transform: "translate(134.637 132.558) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2162",
    "data-name": "Rectangle 2162",
    width: 4.089,
    height: 4.089,
    transform: "translate(136.717 126.637) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2163",
    "data-name": "Rectangle 2163",
    width: 4.089,
    height: 4.089,
    transform: "translate(138.798 120.716) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2164",
    "data-name": "Rectangle 2164",
    width: 4.089,
    height: 4.089,
    transform: "translate(140.878 114.795) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    width: 4.089,
    height: 4.089,
    transform: "translate(128.872 130.532) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    width: 4.089,
    height: 4.089,
    transform: "translate(130.952 124.611) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2167",
    "data-name": "Rectangle 2167",
    width: 4.089,
    height: 4.089,
    transform: "translate(133.033 118.69) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2168",
    "data-name": "Rectangle 2168",
    width: 4.089,
    height: 4.089,
    transform: "translate(135.113 112.769) rotate(-70.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2169",
    "data-name": "Rectangle 2169",
    width: 10.092,
    height: 4.089,
    transform: "matrix(0.332, -0.943, 0.943, 0.332, 123.106, 128.506)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    width: 4.089,
    height: 4.089,
    transform: "translate(127.267 116.665) rotate(-70.634)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2171",
    "data-name": "Rectangle 2171",
    width: 4.089,
    height: 4.089,
    transform: "translate(129.348 110.744) rotate(-70.634)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoYouKnow);
export default __webpack_public_path__ + "static/media/Do-You-Know.94ceca48074efea82a6d1556df93bd6b.svg";
export { ForwardRef as ReactComponent };